if (cleverapps.styles.CrossPromoWindow) {
    cleverapps.overrideStyles(cleverapps.styles.CrossPromoWindow, {
        window: {
            padding: {
                top: 40,
                bottom: 20
            }
        }
    });
}
